var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-combobox",
    {
      staticStyle: { "margin-top": "6px", "padding-top": "0" },
      attrs: {
        items: _vm.items,
        label: _vm.label,
        multiple: "",
        chips: "",
        "single-line": "",
      },
      scopedSlots: _vm._u([
        {
          key: "selection",
          fn: function ({ item, index }) {
            return [
              index <= _vm.maxLength - 1
                ? _c("v-chip", [
                    _c("span", [
                      _vm._v(
                        _vm._s(
                          _vm.elementLengthFilter(item, _vm.elementMaxLength)
                        )
                      ),
                    ]),
                  ])
                : _vm._e(),
              _vm._v(" "),
              index === _vm.maxLength
                ? _c("span", { staticClass: "grey--text caption" }, [
                    _vm._v(
                      "(+ " +
                        _vm._s(_vm.selectedItems.length - _vm.maxLength) +
                        "others)"
                    ),
                  ])
                : _vm._e(),
            ]
          },
        },
      ]),
      model: {
        value: _vm.selectedItems,
        callback: function ($$v) {
          _vm.selectedItems = $$v
        },
        expression: "selectedItems",
      },
    },
    [
      _c(
        "v-list-tile",
        {
          attrs: { slot: "prepend-item", ripple: "" },
          on: {
            click: function ($event) {
              return _vm.selectAll()
            },
          },
          slot: "prepend-item",
        },
        [
          _c(
            "v-list-tile-action",
            [
              _c(
                "v-icon",
                {
                  attrs: {
                    color:
                      _vm.selectedItems.length > 0 ? "indigo darken-4" : "",
                  },
                },
                [_vm._v(_vm._s(_vm.icon))]
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c("v-list-tile-title", [_vm._v("Select All")]),
        ],
        1
      ),
      _vm._v(" "),
      _c("v-divider", {
        staticClass: "mt-2",
        attrs: { slot: "prepend-item" },
        slot: "prepend-item",
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }